import { render, staticRenderFns } from "./volumeseteffort.vue?vue&type=template&id=3b8d613f&"
import script from "./volumeseteffort.vue?vue&type=script&lang=js&"
export * from "./volumeseteffort.vue?vue&type=script&lang=js&"
import style0 from "./volumeseteffort.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports